import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-logo-group">
          <img src="/logo-white.png" alt="Celeritas" />
          <a href="https://discord.gg/mR45gCfark" target="_blank" rel="noopener noreferrer" aria-label="Discord" className="footer-discord">
            <i className="fab fa-discord"></i>
          </a>
        </div>
        <div className="footer-right">
          <nav className="footer-links">
            <Link to="/termos">{t('footer.terms')}</Link>
            <Link to="/privacidade">{t('footer.privacy')}</Link>
          </nav>
          <p className="footer-copy">&copy; 2026 Celeritas</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;